
import { updateRoomIdentify } from '@/api/room-manage';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class extends Vue {
  @Prop() room_id!: number;
  private msg: string = '';
  async getList() {
    try {
      const res = await updateRoomIdentify({ room_id: this.room_id, page: 1, page_size: 100000 });
      const { list } = res.data;

      this.msg = list.length > 0 ? JSON.stringify(list) : '';
    } catch (err) {
      console.log(err);
    }
  }

  mounted() {
    this.getList();
  }
}
